/** 
 * Day count down html
 * 
<tpt-day-countdown data-end-date="06/27/2024" data-end-time="12:35" data-day-left="After __DAYS__ day(s) left" data-time-left="Website go live at: __TIME__" data-enable-utc="true">
	Calculating time to go live
</tpt-day-countdown>
*/

if (!customElements.get('tpt-day-countdown')) {
	customElements.define(
		'tpt-day-countdown',
		class TptDayCountdown extends HTMLElement {
			constructor() {
				super();

				const timeUtc = this.getAttribute('data-enable-utc');
				let utcText = '';

				if (timeUtc == 'true') {
					utcText = ' UTC';
				}

				const endDateTime = this.getAttribute('data-end-date') + ' ' + this.getAttribute('data-end-time') + utcText;
				const dayString = this.getAttribute('data-day-left');
				const timeString = this.getAttribute('data-time-left');

				let finalTimeString = '';

				const days = this.dateDifferenceInDays(new Date(), new Date(endDateTime));

				if (days >= 1) {
					finalTimeString = dayString.replace('__DAYS__', days);
				} else {
					if (timeUtc == 'true') {
						const localDate = new Date(endDateTime);
						const hour = localDate.getHours();
						const minute = localDate.getMinutes();
						const day = localDate.getDate();
						const month = localDate.getMonth() + 1;
						const year = localDate.getFullYear();

						finalTimeString = timeString.replace('__TIME__', hour + ':' + minute + ' ' + month + '/' + day + '/' + year);
					} else {
						finalTimeString = timeString.replace('__TIME__', this.getAttribute('data-end-time') + ' ' + this.getAttribute('data-end-date'));
					}
				}

				this.innerHTML = finalTimeString;
			}

			dateDifferenceInDays(fromDate, endDate) {
				let diffDays;

				diffDays = (endDate - fromDate) / 86_400_000;

				return parseInt(diffDays);
			}
		}
	);
}
